<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M10.1957 8.56771H19.3485C19.4495 9.14931 19.5 9.70486 19.5 10.2344C19.5 12.1181 19.1171 13.7999 18.3512 15.2799C17.5853 16.76 16.4932 17.9167 15.0751 18.75C13.6569 19.5833 12.0305 20 10.1957 20C8.87431 20 7.61606 19.7374 6.42093 19.2122C5.2258 18.6871 4.1948 17.9774 3.32791 17.0833C2.46102 16.1892 1.77298 15.1259 1.26379 13.8932C0.754596 12.6606 0.5 11.3628 0.5 10C0.5 8.63715 0.754596 7.33941 1.26379 6.10677C1.77298 4.87413 2.46102 3.81076 3.32791 2.91667C4.1948 2.02257 5.2258 1.31293 6.42093 0.78776C7.61606 0.262587 8.87431 0 10.1957 0C12.7206 0 14.8878 0.872396 16.6973 2.61719L14.0588 5.23437C13.0236 4.20139 11.7359 3.6849 10.1957 3.6849C9.10997 3.6849 8.10631 3.96701 7.18472 4.53125C6.26312 5.09549 5.533 5.86154 4.99435 6.82943C4.4557 7.79731 4.18638 8.85417 4.18638 10C4.18638 11.1458 4.4557 12.2027 4.99435 13.1706C5.533 14.1385 6.26312 14.9045 7.18472 15.4687C8.10631 16.033 9.10997 16.3151 10.1957 16.3151C10.9279 16.3151 11.6012 16.2109 12.2156 16.0026C12.83 15.7943 13.335 15.5339 13.7306 15.2214C14.1261 14.9089 14.4712 14.553 14.7658 14.1536C15.0604 13.7543 15.2771 13.3767 15.4159 13.0208C15.5548 12.6649 15.6495 12.3264 15.7 12.0052H10.1957V8.56771Z"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'GoogleSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
